export const IMG_CDN_URL =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
export const FETCH_MENU_URL =
  "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&lat=28.477711&lng=77.50676059999999&restaurantId=";

export const restaurantList = [
  {
    type: "restaurant",
    data: {
      type: "F",
      id: "253455",
      name: "TAPAS HIDEOUT",
      uuid: "a5616b8b-0a72-43ac-853a-6a6a5c4f1b68",
      city: "1",
      area: "Indiranagar",
      totalRatingsString: "1000+ ratings",
      cloudinaryImageId: "lxcjdqhpntv5xkj18evk",
      cuisines: ["North Indian", "Snacks"],
      tags: [],
      costForTwo: 30000,
      costForTwoString: "₹300 FOR TWO",
      deliveryTime: 36,
      minDeliveryTime: 36,
      maxDeliveryTime: 36,
      slaString: "36 MINS",
      lastMileTravel: 5.599999904632568,
      slugs: {
        restaurant: "tapas-hideout-indiranagar-indiranagar",
        city: "bangalore",
      },
      cityState: "1",
      address:
        "3167, ESI Hospital Road, Indiranagar, HAL 2nd Stage, Bengaluru, Karnataka 560008",
      locality: "HAL 2nd Stage",
      parentId: 327499,
      unserviceable: false,
      veg: false,
      select: false,
      favorite: false,
      tradeCampaignHeaders: [],
      ribbon: [
        {
          type: "PROMOTED",
        },
      ],
      chain: [],
      feeDetails: {
        fees: [
          {
            name: "distance",
            fee: 4800,
            message: "",
          },
          {
            name: "time",
            fee: 0,
            message: "",
          },
          {
            name: "special",
            fee: 0,
            message: "",
          },
        ],
        totalFees: 4800,
        message: "",
        title: "Delivery Charge",
        amount: "4800",
        icon: "",
      },
      availability: {
        opened: true,
        nextOpenMessage: "",
        nextCloseMessage: "",
      },
      longDistanceEnabled: 0,
      rainMode: "NONE",
      thirdPartyAddress: false,
      thirdPartyVendor: "",
      adTrackingID: "cid=6852413~p=1~eid=00000188-6be8-0bc5-01f4-b92800700177",
      badges: {
        imageBased: [],
        textBased: [],
        textExtendedBadges: [],
      },
      lastMileTravelString: "5.5 kms",
      hasSurge: false,
      aggregatedDiscountInfoV3: {
        header: "15% OFF",
        subHeader: "UPTO ₹45",
        discountTag: "",
        headerTypeV2: 0,
      },
      sla: {
        restaurantId: "253455",
        deliveryTime: 36,
        minDeliveryTime: 36,
        maxDeliveryTime: 36,
        lastMileTravel: 5.599999904632568,
        lastMileDistance: 0,
        serviceability: "SERVICEABLE",
        rainMode: "NONE",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        iconType: "EMPTY",
      },
      promoted: true,
      avgRating: "4.0",
      totalRatings: 1000,
      new: false,
    },
    subtype: "basic",
  },
  {
    type: "restaurant",
    data: {
      type: "F",
      id: "229",
      name: "Meghana Foods",
      uuid: "4fdd19e2-5d0f-4bde-9c7f-dc3e8d36021f",
      city: "1",
      area: "Koramangala",
      totalRatingsString: "10000+ ratings",
      cloudinaryImageId: "xqwpuhgnsaf18te7zvtv",
      cuisines: [
        "Biryani",
        "Andhra",
        "South Indian",
        "North Indian",
        "Chinese",
        "Seafood",
      ],
      tags: [],
      costForTwo: 50000,
      costForTwoString: "₹500 FOR TWO",
      deliveryTime: 22,
      minDeliveryTime: 22,
      maxDeliveryTime: 22,
      slaString: "22 MINS",
      lastMileTravel: 1.2999999523162842,
      slugs: {
        restaurant: "meghana-foods-5th-block-koramangala",
        city: "bangalore",
      },
      cityState: "1",
      address:
        "124, Near Jyothi Nivas College, 1st Cross, KHB Colony, Koramangala 5th Block, Bangalore",
      locality: "5th Block",
      parentId: 635,
      unserviceable: false,
      veg: false,
      select: false,
      favorite: false,
      tradeCampaignHeaders: [],
      chain: [],
      feeDetails: {
        fees: [
          {
            name: "distance",
            fee: 3200,
            message: "",
          },
          {
            name: "special",
            fee: 2000,
            message: "",
          },
          {
            name: "time",
            fee: 0,
            message: "",
          },
        ],
        totalFees: 5200,
        message: "",
        title: "Delivery Charge",
        amount: "5200",
        icon: "",
      },
      availability: {
        opened: true,
        nextOpenMessage: "",
        nextCloseMessage: "",
      },
      longDistanceEnabled: 0,
      rainMode: "LIGHT",
      thirdPartyAddress: false,
      thirdPartyVendor: "",
      adTrackingID: "",
      badges: {
        imageBased: [],
        textBased: [],
        textExtendedBadges: [],
      },
      lastMileTravelString: "1.2 kms",
      hasSurge: false,
      sla: {
        restaurantId: "229",
        deliveryTime: 22,
        minDeliveryTime: 22,
        maxDeliveryTime: 22,
        lastMileTravel: 1.2999999523162842,
        lastMileDistance: 0,
        serviceability: "SERVICEABLE",
        rainMode: "LIGHT",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        iconType: "EMPTY",
      },
      promoted: false,
      avgRating: "4.3",
      totalRatings: 10000,
      new: false,
    },
    subtype: "basic",
    crouton: {
      type: "RAIN",
      metaInfo: {
        bgColor: "#282C3F",
        icon: "surge_listing_piuzrv",
        textColor: "#ffffff",
        title: "Bad Weather",
        message: "₹20 extra levied on some restaurants",
      },
    },
  },
  {
    type: "restaurant",
    data: {
      type: "F",
      id: "121603",
      name: "Kannur Food Point",
      uuid: "51983905-e698-4e31-b0d7-e376eca56320",
      city: "1",
      area: "Tavarekere",
      totalRatingsString: "10000+ ratings",
      cloudinaryImageId: "bmwn4n4bn6n1tcpc8x2h",
      cuisines: ["Kerala", "Chinese"],
      tags: [],
      costForTwo: 30000,
      costForTwoString: "₹300 FOR TWO",
      deliveryTime: 24,
      minDeliveryTime: 24,
      maxDeliveryTime: 24,
      slaString: "24 MINS",
      lastMileTravel: 3,
      slugs: {
        restaurant: "kannur-food-point-btm",
        city: "bangalore",
      },
      cityState: "1",
      address:
        "6/21,9TH CROSS ,1ST MAIN, VENKATESHWARA LAYOUT,SG PALYA, BENGALURU, - 560093",
      locality: "SG Palya",
      parentId: 20974,
      unserviceable: false,
      veg: false,
      select: false,
      favorite: false,
      tradeCampaignHeaders: [],
      chain: [],
      feeDetails: {
        fees: [
          {
            name: "distance",
            fee: 4000,
            message: "",
          },
          {
            name: "special",
            fee: 2000,
            message: "",
          },
          {
            name: "time",
            fee: 0,
            message: "",
          },
        ],
        totalFees: 6000,
        message: "",
        title: "Delivery Charge",
        amount: "6000",
        icon: "",
      },
      availability: {
        opened: true,
        nextOpenMessage: "",
        nextCloseMessage: "",
      },
      longDistanceEnabled: 0,
      rainMode: "LIGHT",
      thirdPartyAddress: false,
      thirdPartyVendor: "",
      adTrackingID: "",
      badges: {
        imageBased: [],
        textBased: [],
        textExtendedBadges: [],
      },
      lastMileTravelString: "3 kms",
      hasSurge: false,
      aggregatedDiscountInfoV3: {
        header: "50% OFF",
        subHeader: "",
        discountTag: "FLAT DEAL",
        headerTypeV2: 0,
      },
      sla: {
        restaurantId: "121603",
        deliveryTime: 24,
        minDeliveryTime: 24,
        maxDeliveryTime: 24,
        lastMileTravel: 3,
        lastMileDistance: 0,
        serviceability: "SERVICEABLE",
        rainMode: "LIGHT",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        iconType: "EMPTY",
      },
      promoted: false,
      avgRating: "3.9",
      totalRatings: 10000,
      new: false,
    },
    subtype: "basic",
    crouton: {
      type: "RAIN",
      metaInfo: {
        bgColor: "#282C3F",
        icon: "surge_listing_piuzrv",
        textColor: "#ffffff",
        title: "Bad Weather",
        message: "₹20 extra levied on some restaurants",
      },
    },
  },
  {
    type: "restaurant",
    data: {
      type: "F",
      id: "588181",
      name: "Third Wave Coffee",
      uuid: "d80a9a1d-870a-4ee3-ac79-27a00473e267",
      city: "1",
      area: "BTM Layout",
      totalRatingsString: "100+ ratings",
      cloudinaryImageId: "0dca660dbdf2e04f9b861c4426ffd41e",
      cuisines: ["Cafe", "Desserts", "Beverages"],
      tags: [],
      costForTwo: 40000,
      costForTwoString: "₹400 FOR TWO",
      deliveryTime: 29,
      minDeliveryTime: 29,
      maxDeliveryTime: 29,
      slaString: "29 MINS",
      lastMileTravel: 3.799999952316284,
      slugs: {
        restaurant: "third-wave-coffee-btm-btm",
        city: "bangalore",
      },
      cityState: "1",
      address:
        'Thirdwave Coffee, "Sri Krishna Vaibhava",No.248, Ground Floor, 7th Cross, Mico Layout,No.248, Ground Floor, 7th Cross, Mico Layout,BTM Layout, 2nd Stage, Bengaluru, BTMLayout , B.B.M.P South',
      locality: "2nd Stage",
      parentId: 274773,
      unserviceable: false,
      veg: false,
      select: false,
      favorite: false,
      tradeCampaignHeaders: [],
      ribbon: [
        {
          type: "PROMOTED",
        },
      ],
      chain: [],
      feeDetails: {
        fees: [
          {
            name: "distance",
            fee: 4000,
            message: "",
          },
          {
            name: "special",
            fee: 2000,
            message: "",
          },
          {
            name: "time",
            fee: 0,
            message: "",
          },
        ],
        totalFees: 6000,
        message: "",
        title: "Delivery Charge",
        amount: "6000",
        icon: "",
      },
      availability: {
        opened: true,
        nextOpenMessage: "",
        nextCloseMessage: "",
      },
      longDistanceEnabled: 0,
      rainMode: "LIGHT",
      thirdPartyAddress: false,
      thirdPartyVendor: "",
      adTrackingID: "cid=6790101~p=4~eid=00000188-6be8-0bc5-01f4-b9290070046d",
      badges: {
        imageBased: [],
        textBased: [],
        textExtendedBadges: [],
      },
      lastMileTravelString: "3.7 kms",
      hasSurge: false,
      aggregatedDiscountInfoV3: {
        header: "30% OFF",
        subHeader: "UPTO ₹75",
        discountTag: "",
        headerTypeV2: 0,
      },
      sla: {
        restaurantId: "588181",
        deliveryTime: 29,
        minDeliveryTime: 29,
        maxDeliveryTime: 29,
        lastMileTravel: 3.799999952316284,
        lastMileDistance: 0,
        serviceability: "SERVICEABLE",
        rainMode: "LIGHT",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        iconType: "EMPTY",
      },
      promoted: true,
      avgRating: "4.5",
      totalRatings: 100,
      new: false,
    },
    subtype: "basic",
    crouton: {
      type: "RAIN",
      metaInfo: {
        bgColor: "#282C3F",
        icon: "surge_listing_piuzrv",
        textColor: "#ffffff",
        title: "Bad Weather",
        message: "₹20 extra levied on some restaurants",
      },
    },
  },
  {
    type: "restaurant",
    data: {
      type: "F",
      id: "428",
      name: "Biryani Pot",
      uuid: "6db20a8b-dd85-4148-b750-107169f7f826",
      city: "1",
      area: "Btm Layout",
      totalRatingsString: "10000+ ratings",
      cloudinaryImageId: "mdipoyzfzsa7n7igskht",
      cuisines: ["North Indian", "Biryani"],
      tags: [],
      costForTwo: 50000,
      costForTwoString: "₹500 FOR TWO",
      deliveryTime: 22,
      minDeliveryTime: 22,
      maxDeliveryTime: 22,
      slaString: "22 MINS",
      lastMileTravel: 1.7999999523162842,
      slugs: {
        restaurant: "biryani-pot-madiwala-junction-btm",
        city: "bangalore",
      },
      cityState: "1",
      address: "14th  Cross, 4th link Road Maruthi Nagar Madiwala Bangalore 68",
      locality: "Maruti Nagar",
      parentId: 21798,
      unserviceable: false,
      veg: false,
      select: false,
      favorite: false,
      tradeCampaignHeaders: [],
      chain: [],
      feeDetails: {
        fees: [
          {
            name: "distance",
            fee: 3200,
            message: "",
          },
          {
            name: "special",
            fee: 2000,
            message: "",
          },
          {
            name: "time",
            fee: 0,
            message: "",
          },
        ],
        totalFees: 5200,
        message: "",
        title: "Delivery Charge",
        amount: "5200",
        icon: "",
      },
      availability: {
        opened: true,
        nextOpenMessage: "",
        nextCloseMessage: "",
      },
      longDistanceEnabled: 0,
      rainMode: "LIGHT",
      thirdPartyAddress: false,
      thirdPartyVendor: "",
      adTrackingID: "",
      badges: {
        imageBased: [],
        textBased: [],
        textExtendedBadges: [],
      },
      lastMileTravelString: "1.7 kms",
      hasSurge: false,
      aggregatedDiscountInfoV3: {
        header: "20% OFF",
        subHeader: "UPTO ₹50",
        discountTag: "",
        headerTypeV2: 0,
      },
      sla: {
        restaurantId: "428",
        deliveryTime: 22,
        minDeliveryTime: 22,
        maxDeliveryTime: 22,
        lastMileTravel: 1.7999999523162842,
        lastMileDistance: 0,
        serviceability: "SERVICEABLE",
        rainMode: "LIGHT",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        iconType: "EMPTY",
      },
      promoted: false,
      avgRating: "3.9",
      totalRatings: 10000,
      new: false,
    },
    subtype: "basic",
    crouton: {
      type: "RAIN",
      metaInfo: {
        bgColor: "#282C3F",
        icon: "surge_listing_piuzrv",
        textColor: "#ffffff",
        title: "Bad Weather",
        message: "₹20 extra levied on some restaurants",
      },
    },
  },
  {
    type: "restaurant",
    data: {
      type: "F",
      id: "425",
      name: "Hotel Empire",
      uuid: "ca14df67-0cfd-482c-a5a5-d0437a2aecce",
      city: "1",
      area: "The Forum Mall",
      totalRatingsString: "10000+ ratings",
      cloudinaryImageId: "un4omn7rcunkmlw6vikr",
      cuisines: ["North Indian", "Kebabs", "Biryani"],
      tags: [],
      costForTwo: 45000,
      costForTwoString: "₹450 FOR TWO",
      deliveryTime: 23,
      minDeliveryTime: 23,
      maxDeliveryTime: 23,
      slaString: "23 MINS",
      lastMileTravel: 1.2999999523162842,
      slugs: {
        restaurant: "hotel-empire-5th-block-koramangala",
        city: "bangalore",
      },
      cityState: "1",
      address:
        "103, Industrial Area, 5th Block, Near Jyothi Nivas College, Koramangala 5th Block, Bangalore",
      locality: "Koramangala",
      parentId: 475,
      unserviceable: false,
      veg: false,
      select: false,
      favorite: false,
      tradeCampaignHeaders: [],
      chain: [],
      feeDetails: {
        fees: [
          {
            name: "distance",
            fee: 3200,
            message: "",
          },
          {
            name: "special",
            fee: 2000,
            message: "",
          },
          {
            name: "time",
            fee: 0,
            message: "",
          },
        ],
        totalFees: 5200,
        message: "",
        title: "Delivery Charge",
        amount: "5200",
        icon: "",
      },
      availability: {
        opened: true,
        nextOpenMessage: "",
        nextCloseMessage: "",
      },
      longDistanceEnabled: 0,
      rainMode: "LIGHT",
      thirdPartyAddress: false,
      thirdPartyVendor: "",
      adTrackingID: "",
      badges: {
        imageBased: [],
        textBased: [],
        textExtendedBadges: [],
      },
      lastMileTravelString: "1.2 kms",
      hasSurge: false,
      aggregatedDiscountInfoV3: {
        header: "10% OFF",
        subHeader: "UPTO ₹40",
        discountTag: "",
        headerTypeV2: 0,
      },
      sla: {
        restaurantId: "425",
        deliveryTime: 23,
        minDeliveryTime: 23,
        maxDeliveryTime: 23,
        lastMileTravel: 1.2999999523162842,
        lastMileDistance: 0,
        serviceability: "SERVICEABLE",
        rainMode: "LIGHT",
        longDistance: "NOT_LONG_DISTANCE",
        preferentialService: false,
        iconType: "EMPTY",
      },
      promoted: false,
      avgRating: "4.0",
      totalRatings: 10000,
      new: false,
    },
    subtype: "basic",
    crouton: {
      type: "RAIN",
      metaInfo: {
        bgColor: "#282C3F",
        icon: "surge_listing_piuzrv",
        textColor: "#ffffff",
        title: "Bad Weather",
        message: "₹20 extra levied on some restaurants",
      },
    },
  },
];
